<template>
  <div class="container-fluid">
    <div style="margin-bottom: 6px;margin-top:50px">
      <el-table  :header-row-style="{height:'100px',fontSize:'22px',textAlign:'center'}" :header-cell-style="{background:'#0077cc',color:'white'}" :cell-style="{background:'#f0ffff',color:'black'}" :row-style="{height:'150px',fontSize:'24px'}" size="medium" stripe border :data="list" empty-text="data is empty">
        <el-table-column align="center" prop="new_activation_devices_today" label="New activation devices today"></el-table-column>
        <el-table-column align="center" prop="active_devices_today" label="Active devices today"></el-table-column>
        <el-table-column align="center" prop="new_activation_devices_yesterday" label="New activation devices yesterday"></el-table-column>
        <el-table-column align="center" prop="cumulative_activation_devices" label="Cumulative activation devices"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ProductOverview',
    components: {},
    data () {
      return {
        list: [],
      }
    },
    created () {
      this.getData()
    },
    mounted () {
    },
    methods: {
      getData () {
        this.$api.rootV1.post('/web/statistics/activationInfo', {},
          (res) => {
            let data=res.data;
            let list=[];
            list.push(data)
            this.list=list;
        })
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/statistics/ProductOverview.vue